import axios from "axios";
import { getAuthRequestConfig, getBaseUrl } from "@/services/api/baseUrl";

/**
 * Fetching and saving an invoice PDF, shared by the detail viewer's
 * `useInvoiceFile` hook and the queue's bulk download. There is no bulk file
 * endpoint, so downloading a selection is one request per invoice.
 */
export async function fetchInvoiceFile(invoiceGuid) {
  const response = await axios.get(`${getBaseUrl()}invoices/${invoiceGuid}/file`, {
    ...getAuthRequestConfig({ Accept: "application/pdf" }),
    responseType: "blob",
  });

  return response.data instanceof Blob
    ? response.data
    : new Blob([response.data], { type: "application/pdf" });
}

export function saveBlob(blob, fileName = "invoice.pdf") {
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
}

/**
 * A filename that survives a folder full of them: the invoice number where the
 * record has one, falling back to the guid so two "unknown" files cannot
 * silently overwrite each other.
 */
export function invoiceFileName(invoice) {
  const stem = invoice?.invoiceNumber?.trim() || invoice?.id || "invoice";
  return `${stem.replace(/[\\/:*?"<>|]/g, "-")}.pdf`;
}
